import * as React from 'react';
import { Input, Dropdown, Menu} from 'antd';

import MyIcon from './Icon';
const css = require('./index.scss');

export interface IIconProps {
    placeholder: string; // 搜索框placeholder
    searchInputFn: (v: string) => void; // 搜索回调函数
    resetFields: any; // 重置form 为init值
    searchFormSubmit: (inputVal?: any) => void; // 筛选确认回调函数
    resetFieldsHandler?: () => void; // 清空表单
    children?: any; // 筛选Element
    otherElement?: any; // 其他的element
    searchFormClassName?: any; // 筛选框className
    searchInputClassName?: any; // 搜索框 className
    resetBtnClassName?: any; // 清空按钮 className
    subBtnClassName?: any; // 确认按钮 className
    width?: number; // 组件宽度 px 优先级高于className规定的width
    hidelSearch?: boolean; // 是否隐藏搜索只留筛选  默认否
    clearSearch?: () => void; // 清空主搜索 后的回调函数
    hideSelect?: boolean; // 隐藏下拉框
    setInputVal?: (cb: any) => any; // 设置的input 输入框的值
    autoComplete?: boolean; //输入框是否输入后就自动搜索
}

export default function SearchGroup(props: IIconProps) {
    const classNameSearchForm = () => {
        return props.searchFormClassName ? `${css.searchForm} ${props.searchFormClassName}` : css.searchForm;
    };

    const classNameSearchInput = () => {
        if (props.hidelSearch === true) {
            return props.searchInputClassName ? `${css.searchInput} ${props.searchInputClassName} ${css.hiddenInput}` : `${css.searchInput} ${css.hiddenInput}`;
        }
        return props.searchInputClassName ? `${css.searchInput} ${props.searchInputClassName}` : `${css.searchInput}`;
    };

    const resetBtnClassName = () => {
        return props.resetBtnClassName ? `${css.btn} ${css.btnColor} ${props.resetBtnClassName}` : `${css.btn} ${css.btnColor}`;
    };

    const subBtnClassName = () => {
        return props.subBtnClassName ? `${css.btn} ${props.subBtnClassName}` : `${css.btn}`;
    };

    const [lowerStatus, setLowerStatus] = React.useState(false);
    const [inputVal, setInputVal] = React.useState('');
    React.useEffect(() => {
        if (props.setInputVal) {
            props.setInputVal(setInputVal);
        }
    }, []);
    const lowerHandler = () => {
        props.resetFields();
        setLowerStatus(!lowerStatus);
    };
    const searchInputHandler = (e) => {
        e.nativeEvent.stopImmediatePropagation();
        props.searchInputFn(inputVal);
        setLowerStatus(false);
    };

    const onInputClickHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
        e.nativeEvent.stopImmediatePropagation();
        if (e.keyCode !== 13) {
            return;
        }
        props.searchInputFn(inputVal);
        setLowerStatus(false);
    };
    
    const inputChangeHandler = (e) => {
        e.nativeEvent.stopImmediatePropagation();
        setInputVal(e.target.value);
        if(props.autoComplete) {
            props.searchInputFn(e.target.value);
        }
    };
    const searchFormSubmit = () => {
        props.searchFormSubmit(inputVal);
        setLowerStatus(false);
    };
    const resetFieldsHandler = () => {
        if (props.resetFieldsHandler) {
            props.resetFieldsHandler();
        } else {
            props.resetFields();
        }
    };
    const clearSearch = () => {
        setInputVal('');
        props.clearSearch && props.clearSearch();
    };
    const menu = (
        <Menu selectable={false}>
            <Menu.Item  className={classNameSearchForm()} style={{width: `${props.width}px`}}>
                {props.children}
                <div className={css.btnBox}>
                    <div className={resetBtnClassName()} onClick={resetFieldsHandler}>
                        清空
                    </div>
                    <div className={subBtnClassName()} onClick={searchFormSubmit}>
                        筛选
                    </div>
                </div>
            </Menu.Item>
        </Menu>
    );
    return (
        <div className={css.searchGroup} id="searchGroup">
            <Input
                autoComplete="off"
                onChange={inputChangeHandler}
                value={inputVal}
                onKeyUp={onInputClickHandler}
                className={classNameSearchInput()}
                style={{width: `${props.width}px`, borderColor: `${props.hidelSearch ? '#d9d9d9' : '#FFFFFF'}`}}
                placeholder={props.placeholder}
                size={'large'}
                prefix={
                    props.hidelSearch === true ?
                    <div className={css.iconBox}>
                        <MyIcon className={css.filterIcon} src={require('./Icon/filter.svg')}/>
                    </div> :
                    <div className={css.iconBox} onClick={searchInputHandler}>
                        <MyIcon className={css.searchIcon} src={require('./Icon/img.search.svg')}/>
                    </div>
                }
                suffix={
                    <div className={css.suffixBox}>
                        {
                            inputVal ? 
                            <div onClick={clearSearch}>
                                <MyIcon className={css.closeIcon} src={require('./Icon/close.svg')}/>
                            </div> : ''
                        }
                        {
                            props.hideSelect === true ? null :
                            <Dropdown overlay={menu} trigger={['click']} placement="bottomRight" visible={lowerStatus} onVisibleChange={lowerHandler} getPopupContainer={() => document.getElementById('searchGroup')}>
                                <div 
                                    style={ props.hidelSearch ? {
                                        position: 'relative', 
                                        right: '-11px', 
                                        top: '11px',
                                        width: `${props.width}px`,
                                        paddingLeft: `${props.width - 32}px`
                                    } : {
                                        position: 'relative', 
                                        right: '-11px', 
                                        top: '11px'
                                    }}
                                >
                                    <div className={lowerStatus ? `${css.iconBox} ${css.iconBoxPo} ${css.iconBoxBc}` : `${css.iconBox} ${css.iconBoxPo}`}>
                                        <MyIcon className={lowerStatus?`${css.lowerIcon} ${css.lowerIconTransForm}`:`${css.lowerIcon} ${css.lowerIconTransFormInitial}`} src={require('./Icon/lower.svg')}/>
                                    </div>
                                </div>
                            </Dropdown>
                        }
                    </div>
                }
            />
            {props.otherElement}
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/display/components/SearchGroup/index.tsx